import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { StateProvider } from '@State'
import { App } from './components/App'
import { COURSENUM } from './urls'

const initialState = {
  coursenum: COURSENUM,
  certInfo: {
    header: 'Certificate of Completion',
    preamble: 'This is to certify that',
    reason: 'has completed the course',
    award: 'MyEducator Basics',
    image: '',
    imageName: '',
    imageLoaded: false,
    selectedAssessments: [],
    selectedChapters: [],
    passingScore: '50',
    retrievedEditData: false,
    newUploadedImage: false,
    description: '',
  },
  assessments: {},
  chapters: {
    id: '',
    title: '',
    chapterChoices: [],
  },
  finished: false,
  errors: [],
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_CERT_INFO':
      return { ...state, certInfo: { ...state.certInfo, ...action.payload } }
    case 'UPDATE_ASSESSMENTS':
      return { ...state, assessments: action.payload }
    case 'PUSH_ASSESSMENTS':
      return {
        ...state,
        certInfo: { ...state.certInfo, selectedAssessments: action.payload },
      }
    case 'UPDATE_CHAPTERS':
      return { ...state, chapters: action.payload }
    case 'PUSH_CHAPTERS':
      return {
        ...state,
        certInfo: { ...state.certInfo, selectedChapters: action.payload },
      }
    case 'PUSH_PASSING_SCORE':
      return {
        ...state,
        certInfo: { ...state.certInfo, passingScore: action.payload },
      }
    case 'FINISH_CERTIFICATE':
      return { ...state, finished: true }
    case 'SET_ERRORS':
      return { ...state, errors: action.payload }
    default:
      return state
  }
}

const CertificatesApp = () => (
  <Router>
    <StateProvider initialState={initialState} reducer={reducer}>
      <App />
    </StateProvider>
  </Router>
)

export const startCertificatesApp = () => {
  const root = createRoot(document.getElementById('app'))
  root.render(<CertificatesApp />)
}
